import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/icons/close.svg'
import _imports_1 from '@/assets/icons/icon-plus.svg'


const _hoisted_1 = {
  key: 0,
  class: "spinner"
}
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "inputs-col-wr" }
const _hoisted_4 = { class: "company-address-container" }
const _hoisted_5 = { class: "input-row" }
const _hoisted_6 = { class: "input-wr w-100" }
const _hoisted_7 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_8 = { class: "input-row" }
const _hoisted_9 = { class: "input-wr w-100" }
const _hoisted_10 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_11 = { class: "logo-wr" }
const _hoisted_12 = { class: "upload-image-wr" }
const _hoisted_13 = { class: "images-main-wr" }
const _hoisted_14 = {
  key: 0,
  class: "image-wr"
}
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "input-row" }
const _hoisted_17 = { class: "input-wr" }
const _hoisted_18 = { class: "input-wr" }
const _hoisted_19 = { class: "input-wr" }
const _hoisted_20 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "customer-section" }
const _hoisted_23 = { class: "customer-header" }
const _hoisted_24 = { class: "customer-header-actions" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = ["disabled"]
const _hoisted_27 = { class: "customer-count" }
const _hoisted_28 = {
  key: 0,
  class: "customer-table-wr"
}
const _hoisted_29 = { class: "customer-table" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["checked", "onChange"]
const _hoisted_32 = {
  key: 1,
  class: "empty-customer-options"
}
const _hoisted_33 = {
  key: 2,
  class: "error-hint"
}
const _hoisted_34 = { class: "input-row" }
const _hoisted_35 = { class: "input-wr" }
const _hoisted_36 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_37 = { class: "input-wr" }
const _hoisted_38 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_39 = { class: "input-wr" }
const _hoisted_40 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_41 = { class: "actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[25] || (_cache[25] = _createElementVNode("div", { class: "dashboard-header" }, [
      _createElementVNode("h2", { class: "title-main" }, "Update Builder")
    ], -1)),
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : (_openBlock(), _createElementBlock("form", {
          key: 1,
          class: "default-form",
          onSubmit: _withModifiers($setup.onUpdateBuilder, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _cache[11] || (_cache[11] = _createElementVNode("label", { class: "label" }, "Company Name", -1)),
                    _withDirectives(_createElementVNode("input", {
                      class: "input",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.name) = $event)),
                      type: "text",
                      placeholder: "Company"
                    }, null, 512), [
                      [_vModelText, $setup.form.name]
                    ]),
                    ($setup.v$.name.$error)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString($setup.v$.name.$errors[0].$message), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _cache[12] || (_cache[12] = _createElementVNode("label", { class: "label" }, "Street", -1)),
                    _withDirectives(_createElementVNode("input", {
                      class: "input",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.address) = $event)),
                      type: "text",
                      placeholder: "Street"
                    }, null, 512), [
                      [_vModelText, $setup.form.address]
                    ]),
                    ($setup.v$.address.$error)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString($setup.v$.address.$errors[0].$message), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("input", {
                  id: "file-upload",
                  type: "file",
                  onChange: $setup.uploadImage,
                  accept: "image/*"
                }, null, 32),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    ($setup.form.imageFile.data)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createElementVNode("figure", null, [
                            _createElementVNode("img", {
                              src: $setup.form.imageFile.data
                            }, null, 8, _hoisted_15)
                          ]),
                          ($setup.form.imageFile.data)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "remove-logo",
                                onClick: $setup.removeLogo
                              }, [...(_cache[13] || (_cache[13] = [
                                _createElementVNode("img", {
                                  src: _imports_0,
                                  alt: "close"
                                }, null, -1)
                              ]))]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _cache[14] || (_cache[14] = _createElementVNode("label", {
                    class: "upload-image-button",
                    for: "file-upload"
                  }, [
                    _createElementVNode("img", {
                      src: _imports_1,
                      alt: "close"
                    }),
                    _createElementVNode("p", null, "Add Logo")
                  ], -1))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _cache[15] || (_cache[15] = _createElementVNode("label", { class: "label" }, "Builder Color A", -1)),
                _createElementVNode("label", {
                  class: "input-color",
                  style: _normalizeStyle({ 'background-color': $setup.form.color })
                }, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.color) = $event)),
                    type: "color"
                  }, null, 512), [
                    [_vModelText, $setup.form.color]
                  ])
                ], 4)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _cache[16] || (_cache[16] = _createElementVNode("label", { class: "label" }, "Builder Color B", -1)),
                _createElementVNode("label", {
                  class: "input-color",
                  style: _normalizeStyle({ 'background-color': $setup.form.colorB })
                }, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.colorB) = $event)),
                    type: "color"
                  }, null, 512), [
                    [_vModelText, $setup.form.colorB]
                  ])
                ], 4)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _cache[17] || (_cache[17] = _createElementVNode("label", { class: "label" }, "Background Color", -1)),
                _createElementVNode("label", {
                  class: "input-color",
                  style: _normalizeStyle({ 'background-color': $setup.form.colorC })
                }, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.colorC) = $event)),
                    type: "color"
                  }, null, 512), [
                    [_vModelText, $setup.form.colorC]
                  ])
                ], 4)
              ]),
              _createVNode($setup["DropDown"], { class: "dropdown-container input-wr" }, {
                control: _withCtx(() => [
                  _createElementVNode("button", {
                    class: _normalizeClass(["dropdown-button primary", { 'input--error': $setup.v$.state.$error }]),
                    type: "button"
                  }, _toDisplayString($setup.form.state || "Select State"), 3),
                  ($setup.v$.state.$error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString($setup.v$.state.$errors[0].$message), 1))
                    : _createCommentVNode("", true)
                ]),
                dropdown: _withCtx(() => [
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.StatesEnum, (state) => {
                      return (_openBlock(), _createElementBlock("li", {
                        onClick: ($event: any) => ($setup.form.state = state),
                        class: _normalizeClass({ 'dropdown__item-active': $setup.form.state === state }),
                        key: state
                      }, _toDisplayString(state), 11, _hoisted_21))
                    }), 128))
                  ])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _cache[18] || (_cache[18] = _createElementVNode("label", { class: "label" }, "Customers", -1)),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("button", {
                    class: "button-text",
                    type: "button",
                    disabled: !$setup.customerOptions.length,
                    onClick: $setup.checkAllCustomers
                  }, "Check All", 8, _hoisted_25),
                  _createElementVNode("button", {
                    class: "button-text",
                    type: "button",
                    disabled: !$setup.customerOptions.length,
                    onClick: $setup.uncheckAllCustomers
                  }, "Uncheck All", 8, _hoisted_26),
                  _createElementVNode("span", _hoisted_27, _toDisplayString($setup.selectedCustomersCount) + " selected", 1)
                ])
              ]),
              ($setup.customerOptions.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createElementVNode("table", _hoisted_29, [
                      _cache[19] || (_cache[19] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th"),
                          _createElementVNode("th", null, "Company"),
                          _createElementVNode("th", null, "Admin Email")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.customerOptions, (customer) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: customer.detailsId,
                            onClick: ($event: any) => ($setup.toggleCustomer(customer))
                          }, [
                            _createElementVNode("td", null, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                checked: $setup.isCustomerSelected(customer),
                                onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"])),
                                onChange: ($event: any) => ($setup.toggleCustomer(customer))
                              }, null, 40, _hoisted_31)
                            ]),
                            _createElementVNode("td", null, _toDisplayString(customer.companyName), 1),
                            _createElementVNode("td", null, _toDisplayString(customer.adminEmail), 1)
                          ], 8, _hoisted_30))
                        }), 128))
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_32, "No customers found")),
              ($setup.v$.landownerIds.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString($setup.v$.landownerIds.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ]),
            _cache[24] || (_cache[24] = _createElementVNode("div", { class: "divider" }, null, -1)),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _cache[20] || (_cache[20] = _createElementVNode("label", { class: "label" }, "Contact Person", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: "input",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.form.contact) = $event)),
                  type: "text",
                  placeholder: "Full Name"
                }, null, 512), [
                  [_vModelText, $setup.form.contact]
                ]),
                ($setup.v$.contact.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString($setup.v$.contact.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_37, [
                _cache[21] || (_cache[21] = _createElementVNode("label", { class: "label" }, "Email", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: "input",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.form.email) = $event)),
                  type: "email",
                  placeholder: "john.smith@gmail.com"
                }, null, 512), [
                  [_vModelText, $setup.form.email]
                ]),
                ($setup.v$.email.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString($setup.v$.email.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_39, [
                _cache[22] || (_cache[22] = _createElementVNode("label", { class: "label" }, "Phone Number", -1)),
                _createVNode($setup["Cleave"], {
                  class: "input-default",
                  modelValue: $setup.form.phone,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.form.phone) = $event)),
                  options: $setup.phoneNumberOption($setup.form.phone),
                  placeholder: "0412 345 678"
                }, null, 8, ["modelValue", "options"]),
                ($setup.v$.phone.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString($setup.v$.phone.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _cache[23] || (_cache[23] = _createElementVNode("button", {
                class: "button default primary create-btn",
                type: "submit"
              }, "Update", -1)),
              _createElementVNode("button", {
                class: "button default outlined cancel-btn",
                onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.router.go(-1))),
                type: "button"
              }, "Cancel")
            ])
          ])
        ], 32)),
    _createVNode($setup["ImageCropperModal"], {
      isOpen: $setup.isCropperModalOpen,
      aspectRatio: null,
      onClose: _cache[10] || (_cache[10] = ($event: any) => ($setup.isCropperModalOpen = false)),
      image: $setup.imageForCropper,
      onOnCropImage: $setup.onCropImage
    }, null, 8, ["isOpen", "image"])
  ], 64))
}